<template>
  <div class="user">
    <div class="login">
      <ul class="login-tabbar">
        <li class="login-tabbar__item" :class="{ 'login-tabbar__item--active': loginMode === 'username' }" @click="toggleLoginMode('username')">账号登录</li>
        <li class="login-tabbar__item" :class="{ 'login-tabbar__item--active': loginMode === 'mobile' }" @click="toggleLoginMode('mobile')">手机号登录</li>
      </ul>
      <ul class="login-form-content">
        <li class="login-form-content__username" v-if="loginMode==='username'">
          <username-login></username-login>
        </li>
        <li class="login-form-content__phone" v-else>
          <mobile-login></mobile-login>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import UsernameLogin from "./UsernameLogin.vue";
  import MobileLogin from "./MobileLogin.vue";

  export default {
    name: "Login",
    components: {
      UsernameLogin,
      MobileLogin
    },
    data() {
      return {
        loginMode: "username"//默认账号登录
      };
    },
    created() {
    },
    methods: {
      toggleLoginMode(mode) {
        this.loginMode = mode;
      }
    }
  };
</script>
<style lang="less">

  .el-form-item {
    margin-bottom: 30px;
  }

</style>

<style scoped lang="less">
  .user {
    height: calc(100vh - 380px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login {
    width: 500px;

    &-tabbar {
      display: flex;

      &__item {
        padding-bottom: 8px;
        margin-right: 30px;
        cursor: pointer;
        font-weight: @font-weight-primary;
        font-size: @font-size-large;
        color: @secondary-text-color;

        &:hover {
          color: @main-color;
        }

        &--active {
          border-bottom: 2px solid @main-color;
          color: @main-color;
        }
      }
    }

    &-form-content {
      margin: 40px 0;
    }
  }
</style>
